module.exports = __webpack_public_path__ + "media/images/rahnu2-fad9fa46bab6da4adbcc21c7d9697734.svg";